import { Phone, MessageCircle } from "lucide-react";
import { FLOATING } from "@/constants/testIds";
import { telHref, waHref } from "@/constants/site";
import useCallTracking from "@/hooks/useCallTracking";

export default function FloatingCTAs() {
  const trackCall = useCallTracking();
  return (
    <div className="fixed bottom-5 left-5 z-40 hidden lg:flex flex-col gap-3">
      <a
        data-testid={FLOATING.whatsapp}
        href={waHref()}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="WhatsApp TyresPro"
        className="w-14 h-14 rounded-full bg-[#25D366] text-white flex items-center justify-center shadow-lg hover:scale-105 transition-transform"
      >
        <MessageCircle className="w-6 h-6" strokeWidth={2} />
      </a>
      <a
        data-testid={FLOATING.call}
        href={telHref}
        onClick={trackCall("floating")}
        aria-label="Call TyresPro"
        className="w-14 h-14 rounded-full bg-[#1E63FF] text-white flex items-center justify-center shadow-lg hover:scale-105 transition-transform pulse-blue"
      >
        <Phone className="w-6 h-6" strokeWidth={2} />
      </a>
    </div>
  );
}
